import ABTestBranchActionMetadata from 'automation-ui-action-features/actions/ab-test-branch/records/ABTestBranchActionMetadata';
import AdsAudienceMembershipActionMetadata from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadata';
import AlterListMembershipActionMetadata from 'automation-ui-action-features/actions/alter-list-membership/AlterListMembershipActionMetadata';
import ClassicAnchoredDelayActionMetadata from 'automation-ui-action-features/actions/classic-anchored-delay/records/ClassicAnchoredDelayActionMetadata';
import ClassicCopyCompanyPropertyActionMetadata from 'automation-ui-action-features/actions/classic-copy-company-property/records/ClassicCopyCompanyPropertyActionMetadata';
import ClassicEnrollInWorkflowActionMetadata from 'automation-ui-action-features/actions/classic-enroll-in-flow/ClassicEnrollInWorkflowActionMetadata';
import ClassicNotificationEmailActionMetadata from 'automation-ui-action-features/actions/classic-notification-email/records/ClassicNotificationEmailActionMetadata';
import ClassicVirtualAnchoredDelayActionMetadata from 'automation-ui-action-features/actions/classic-virtual-anchored-delay/records/ClassicVirtualAnchoredDelayActionMetadata';
import CreateObjectActionMetadata from 'automation-ui-action-features/actions/create-object/records/CreateObjectActionMetadata';
import CreateSalesforceCampaignActionMetadata from 'automation-ui-action-features/actions/create-salesforce-campaign/CreateSalesforceCampaignActionMetadata';
import CreateSalesforceTaskActionMetadata from 'automation-ui-action-features/actions/create-salesforce-task/CreateSalesforceTaskActionMetadata';
import CreateTaskActionMetadata from 'automation-ui-action-features/actions/create-task/records/CreateTaskActionMetadata';
import CustomCodeActionMetadata from 'automation-ui-action-features/actions/custom-code/records/CustomCodeActionMetadata';
import DelayUntilDateActionMetadata from 'automation-ui-action-features/actions/delay-until-date/DelayUntilDateActionMetadata';
import DelayActionMetadata from 'automation-ui-action-features/actions/delay/records/DelayActionMetadata';
import EmailNotificationActionMetadata from 'automation-ui-action-features/actions/email-notification/EmailNotificationActionMetadata';
import EmailActionMetadata from 'automation-ui-action-features/actions/email/EmailActionMetadata';
import EmptyActionMetadata from 'automation-ui-action-features/actions/empty-action/EmptyActionMetadata';
import EnrollInFlowActionMetadata from 'automation-ui-action-features/actions/enroll-in-flow/records/EnrollInFlowActionMetadata';
import ExtensionActionMetadata from 'automation-ui-action-features/actions/extension/ExtensionActionMetadata';
import FormulaActionMetadata from 'automation-ui-action-features/actions/formula/FormulaActionMetadata';
import GoToActionMetadata from 'automation-ui-action-features/actions/go-to/records/GoToActionMetadata';
import InAppNotificationActionMetadata from 'automation-ui-action-features/actions/in-app-notification/InAppNotificationActionMetadata';
import ListBranchActionMetadata from 'automation-ui-action-features/actions/list-branch/records/ListBranchActionMetadata';
import RotateObjectActionMetadata from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionMetadata';
import SendInternalSMSActionMetadata from 'automation-ui-action-features/actions/send-internal-sms/records/SendInternalSMSActionMetadata';
import SetPropertyActionMetadata from 'automation-ui-action-features/actions/set-property/SetPropertyActionMetadata';
import SlackActionMetadata from 'automation-ui-action-features/actions/slack/records/SlackActionMetadata';
import StaticBranchActionMetadata from 'automation-ui-action-features/actions/static-branch/StaticBranchActionMetadata';
import VirtualScheduledEnrollmentActionMetadata from 'automation-ui-action-features/actions/virtual-scheduled-enrollment/records/VirtualScheduledEnrollmentActionMetadata';
import WaitUntilActionMetadata from 'automation-ui-action-features/actions/wait-until/records/WaitUntilActionMetadata';
import WebhookActionMetadata from 'automation-ui-action-features/actions/webhook/records/WebhookActionMetadata';
import WhileLoopActionMetadata from 'automation-ui-action-features/actions/while-loop/WhileLoopActionMetadata';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import ClassicAlterListMembershipActionMetadata from 'automation-ui-action-features/deprecated/alter-list-membership/ClassicAlterListMembershipActionMetadata';
import SetMarketingStatusActionMetadata from 'automation-ui-action-features/deprecated/set-marketing-status/SetMarketingStatusActionMetadata';
import SetSubscriptionsActionMetadata from 'automation-ui-action-features/deprecated/set-subscriptions/SetSubscriptionsActionMetadata';
import { getActionType, getMetadata } from 'automation-ui-action-features/records/recordsUtils';
import { BaseImmutableObject } from 'immutable-less/BaseImmutableObject';
export const buildMetadataForAction = (actionOptions, extraOpts = {}) => {
  const metadata = getMetadata(actionOptions);
  const rawMetadata = metadata instanceof BaseImmutableObject ? metadata.toJS() : metadata;
  const actionType = getActionType(actionOptions);
  switch (actionType) {
    case ActionTypes.TASK:
      return new CreateTaskActionMetadata(rawMetadata);
    case ActionTypes.EMAIL:
      return new EmailActionMetadata(rawMetadata);
    case ActionTypes.EMAIL_NOTIFICATION:
      return new EmailNotificationActionMetadata(rawMetadata);
    case ActionTypes.CUSTOM_CODE:
      return new CustomCodeActionMetadata(rawMetadata);
    case ActionTypes.DELAY:
      return new DelayActionMetadata(rawMetadata);
    case ActionTypes.DELAY_UNTIL_DATE:
      return new DelayUntilDateActionMetadata(rawMetadata);
    case ActionTypes.WAIT_UNTIL:
      return new WaitUntilActionMetadata(rawMetadata);
    case ActionTypes.SET_PROPERTY:
      return new SetPropertyActionMetadata(rawMetadata);
    case ActionTypes.SLACK_NOTIFICATION:
      return new SlackActionMetadata(rawMetadata);
    case ActionTypes.LIST_BRANCH:
      return new ListBranchActionMetadata(rawMetadata);
    case ActionTypes.ENROLL_IN_FLOW:
      return new EnrollInFlowActionMetadata(rawMetadata);
    case ActionTypes.IN_APP_NOTIFICATION:
      return new InAppNotificationActionMetadata(rawMetadata);
    case ActionTypes.CREATE_OBJECT:
      return new CreateObjectActionMetadata(rawMetadata);
    case ActionTypes.ROTATE_OBJECT:
      return new RotateObjectActionMetadata(rawMetadata);
    case ActionTypes.ALTER_LIST_MEMBERSHIP:
      return new AlterListMembershipActionMetadata(rawMetadata);
    case ActionTypes.WEBHOOK:
      return new WebhookActionMetadata(rawMetadata);
    case ActionTypes.SEND_SMS_NOTIFICATION:
      return new SendInternalSMSActionMetadata(rawMetadata);
    case ActionTypes.CREATE_SALESFORCE_CAMPAIGN:
      return new CreateSalesforceCampaignActionMetadata(rawMetadata);
    case ActionTypes.CREATE_SALESFORCE_TASK:
      return new CreateSalesforceTaskActionMetadata(rawMetadata);
    case ActionTypes.AUTOMATION_EXTENSION:
      return new ExtensionActionMetadata(rawMetadata, extraOpts.actionDefinition);
    case ActionTypes.CLASSIC_COPY_COMPANY_PROPERTY:
      return new ClassicCopyCompanyPropertyActionMetadata(rawMetadata);
    case ActionTypes.CLASSIC_ENROLL_IN_WORKFLOW:
      return new ClassicEnrollInWorkflowActionMetadata(rawMetadata);
    case ActionTypes.CLASSIC_NOTIFICATION_EMAIL:
      return new ClassicNotificationEmailActionMetadata(rawMetadata);
    case ActionTypes.CLASSIC_ANCHORED_DELAY:
      return new ClassicAnchoredDelayActionMetadata(rawMetadata);
    case ActionTypes.CLASSIC_VIRTUAL_ANCHORED_DELAY:
      return new ClassicVirtualAnchoredDelayActionMetadata(rawMetadata);
    case ActionTypes.VIRTUAL_SCHEDULED_ENROLLMENT:
      return new VirtualScheduledEnrollmentActionMetadata(rawMetadata);
    case ActionTypes.GO_TO:
      return new GoToActionMetadata(rawMetadata);
    case ActionTypes.ADS_AUDIENCE_MEMBERSHIP:
      return new AdsAudienceMembershipActionMetadata(rawMetadata);
    case ActionTypes.STATIC_BRANCH:
      return new StaticBranchActionMetadata(rawMetadata);
    case ActionTypes.AB_TEST_BRANCH:
      return new ABTestBranchActionMetadata(rawMetadata);
    case ActionTypes.FORMULA:
      return new FormulaActionMetadata(rawMetadata);
    case ActionTypes.WHILE_LOOP:
      return new WhileLoopActionMetadata(rawMetadata);
    case ActionTypes.ALL_BRANCHES:
      return rawMetadata;
    case ActionTypes.ALL_DELAYS:
      return rawMetadata;
    /**
     * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
     * Keeping around for backwards compatibility.
     */
    case ActionTypes.CLASSIC_ALTER_LIST_MEMBERSHIP:
      return new ClassicAlterListMembershipActionMetadata(rawMetadata);
    /**
     * @deprecated Built-in action migrated to Actions API. Keeping around for
     * backwards compatibility.
     */
    case ActionTypes.SET_MARKETING_STATUS:
      return new SetMarketingStatusActionMetadata(rawMetadata);
    case ActionTypes.UPDATE_EMAIL_SUBSCRIPTION:
      return new SetSubscriptionsActionMetadata(rawMetadata);
    case ActionTypes.EMPTY_ACTION:
      return new EmptyActionMetadata();
    default:
      // Can happen when loading workflows containing deprecated actions that are
      // no longer recognized (or have been created with a beta version of the app)
      console.warn(`Unrecognized action type: ${actionType}. Please add it to factories.buildMetadataForAction()`);
      return null;
  }
};